import React, { useState, useEffect } from "react";
import { Box, Container, Skeleton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getUser } from "../../Utils/authHelper";
import ComboCard from "../ComboCard/ComboCard";
import ScrollRow from "../ScrollRow/ScrollRow";
import SectionHeading from "../SectionHeading/SectionHeading";

const API_URL = "https://api.glamcompany.in/api/v1/";

const ComboSection = () => {
    const [combos, setCombos] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const user = getUser();
    const isBusiness = user?.customerType === 'business';

    useEffect(() => {
        const fetchCombos = async () => {
            try {
                const res = await fetch(`${API_URL}combo-offer/all`);
                const data = await res.json();
                if (data.success) setCombos(data.data || []);
            } catch (e) {
                console.error("Failed to fetch combo offers:", e);
            } finally {
                setLoading(false);
            }
        };
        fetchCombos();
    }, []);

    if (!loading && combos.length === 0) return null;

    return (
        <Box sx={{ py: { xs: 2.5, md: 3.5 }, bgcolor: "#fdfbf7" }}>
            <Container maxWidth="xl">
                <SectionHeading kicker="Save More Together" title="Combo Packs" onAction={() => navigate("/combos")} />

                <ScrollRow gap={2}>
                    {loading
                        ? Array.from({ length: 6 }).map((_, i) => (
                            <Box key={i} sx={{ width: { xs: 160, sm: 190, md: 210 }, flexShrink: 0 }}>
                                <Skeleton variant="rectangular" sx={{ aspectRatio: "1/1", height: "auto", borderRadius: "12px", mb: 1 }} />
                                <Skeleton width="80%" height={18} />
                                <Skeleton width="40%" height={18} />
                            </Box>
                        ))
                        : combos.map((combo) => (
                            <ComboCard key={combo._id} combo={combo} isBusiness={isBusiness} width={{ xs: 160, sm: 190, md: 210 }} showPercent={false} />
                        ))}
                </ScrollRow>
            </Container>
        </Box>
    );
};

export default ComboSection;
